<template>
<div class="chapter">
<div class="inner_page">
<div class="figure">
<img alt="Never Let Them See You Cry" src="images/cover_11464.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?3ec4bad5